import React, { Fragment, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button } from "@mui/material";
import { AssetLocation, AssetLocationTypes } from "../../../../../logic/api";

import LocationPickerDialog from "../../../../../components/pickers/locationPicker/LocationPickerDialog";
import { useTranslation } from "react-i18next";


const LaneAllocationLocationPicker: React.FunctionComponent<{

    value: string;
    onChange: (value: string) => void;
    selectionTypes: AssetLocationTypes[],
    displayTypes: AssetLocationTypes[],
}> = (props) => {
    let initalValue: AssetLocation | null = null;

    if (props.value != null) {
        try {
            initalValue = JSON.parse(props.value);
        } catch (ex) {
            initalValue = null;
        }

    }

    const { t } = useTranslation();
    const [value, setValue] = useState<AssetLocation | null>(initalValue);
    const [showLocationPicker, setShowLocationPicker] = useState<boolean>(false);

    useEffect(() => {
        setValue(initalValue);
    }, [props.value]);
    return <Fragment>
        <LocationPickerDialog
            title={t("keys.labels.selectLocation")}
            show={showLocationPicker}
            displayTypes={props.displayTypes}
            selectionTypes={props.selectionTypes}
            onChange={(location) => {
                if (location != null) {
                    setValue(location);
                    props.onChange(JSON.stringify(location));
                }

                setShowLocationPicker(false);
            }}
        />
        {value == null && (
            <Button style={{ width: "100%" }} variant="contained" color="secondary" onClick={() => {
                setShowLocationPicker(true);
            }}>{t("keys.labels.selectLocation")}</Button>
        )}
        {value != null && (
            <Button style={{ width: "100%" }} variant="contained" color="primary" onClick={() => {
                setShowLocationPicker(true);
            }}>{value.type == AssetLocationTypes.Zone ? `${value.name} (any)` : `${value.name}, ${value.parentName}`}</Button>
        )}


    </Fragment >;
}
LaneAllocationLocationPicker.propTypes = {

    value: propTypes.any,
    onChange: propTypes.func.isRequired,
    displayTypes: propTypes.array.isRequired,
    selectionTypes: propTypes.array.isRequired,
}

export default LaneAllocationLocationPicker;